import React from "react";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import { Formik, Field } from "formik";
import Grid from "@material-ui/core/Grid";
import { AdminView } from "./admin_view.component";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import { Api } from "../../utils/api";
import { RequestDetailsForm } from "../forms/request-details.form";
import { MaterialSelectFormik } from "./select-field.component";
import { object, string, number } from "yup";
import { isEmpty } from "lodash";

const REQUEST_PERIODS = [
  "",
  "Hoje ou Dentro de Dias",
  "Este mês ou no Próximo",
  "Não sei",
];

const validationSchemaStandby = object().shape({
  standby_motive: number().required("Obrigatório"),
});

const validationSchemaCancel = object().shape({
  cancel_reason: string().required("Obrigatório"),
});

export class RequestDetailsCard extends React.Component {
  state = {
    cancelOpen: false,
    standbyOnOpen: false,
    standbyOffOpen: false,
    options: [],
  };

  validationCancelMotive = [
    { value: "job", label: "Emprego" },
    { value: "suppliers", label: "Fornecedores" },
    { value: "repeated", label: "Repetido" },
    { value: "relatives", label: "Familiares" },
    { value: "mistake", label: "Engano" },
    { value: "solved", label: "Resolvido" },
    { value: "other_valence", label: "Outra Valência" },
    { value: "professionals", label: "Profissionais" },
    { value: "internship", label: "Estágio" },
    { value: "firemen", label: "Bombeiros" },
    { value: "mortuary", label: "Funerária" },
    { value: "police", label: "Polícia" },
    { value: "volunteering", label: "Voluntariado" },
    { value: "member_subscriber", label: "Sócios/Inscritos" },
    { value: "no_help", label: "Não quer ajuda" },
    { value: "no_decision_maker", label: "Não é o decisor" },
    { value: "future_application", label: "Incrição p/ futuro" },
    { value: "IPSS_only", label: "Só quer IPSS" },
    { value: "potential_client", label: "Potencial cliente" },
    { value: "customer", label: "Cliente" },
    { value: "prices_only", label: "Só quer preços" },
    { value: "death", label: "Falecimento" },
    { value: "other", label: "Outro" },
  ];

  exclusiveCancelMotive = [
    { value: "other_way", label: "Encontrou lar por outra via" },
    { value: "death", label: "Idoso(a) faleceu" },
    { value: "care_taker", label: "Colocação de cuidador em casa" },
    { value: "home_support", label: "Optou com Apoio Domiciliário" },
    { value: "day_center", label: "Optou com Centro de Dia" },
    { value: "IPPS", label: "Chamado(a) para IPSS" },
    { value: "cc", label: "Chamado(a) para CC" },
    { value: "hospital", label: "Internamento, estado crítico" },
    { value: "other", label: "Outro" },
  ];

  disperseCancelMotive = [
    { value: "client_requested", label: "A pedido do emissor" },
  ];

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.setForm = this.setForm.bind(this);
    this.submit = this.submit.bind(this);
    this.isSubmitting = this.isSubmitting.bind(this);
    this.setStandbyForm = this.setStandbyForm.bind(this);
    this.setCancelForm = this.setCancelForm.bind(this);
    this.submitCancelForm = this.submitCancelForm.bind(this);
    this.isSubmittingCancelForm = this.isSubmittingCancelForm.bind(this);
    this.standbyOptionsPromise = this.standbyOptionsPromise.bind(this);
    this.setStandby = this.setStandby.bind(this);
    this.turnOffStandby = this.turnOffStandby.bind(this);
  }

  standbyOptionsPromise = () => {
    return this.api
      .get("/standby_motives")
      .then((res) => res.data)
      .then(this.optionsToSelect);
  };

  optionsToSelect = (options) => {
    return options.map((option) => ({
      value: option.id,
      label: option.motives,
    }));
  };

  handleCancelOpen = () => {
    this.setState({ cancelOpen: true });
  };

  //abrir diálogo p activar standby
  openDialogTurnOnStandby = () => {
    this.setState({ standbyOnOpen: true });
  };

  //colocar pedido em standby
  setStandby = (values) => {
    this.api
      .patch(`user_requests/${this.props.request.id}`, {
        standby: 1,
        standby_motive: parseInt(values.standby_motive),
      })
      .then(() => {
        this.api.post(`standby_regists`, {
          user_request_id: this.props.request.id,
          user_id: localStorage.id,
          standby_status: 1,
          motive: parseInt(values.standby_motive),
        });
      })
      .then(() => {
        this.handleStandbyClose();
      })
      .then(() => {
        this.props.getUserRequestInfo();
      });
  };

  //abrir dialogo p retirar o pedido de standby
  openDialogTurnOffStandby = () => {
    this.setState({ standbyOffOpen: true });
  };

  //retirar pedido de standby
  turnOffStandby = () => {
    this.api
      .patch(`user_requests/${this.props.request.id}`, {
        standby: 0,
        standby_motive: null,
      })
      .then(() => {
        this.api.post(`standby_regists`, {
          user_request_id: this.props.request.id,
          user_id: localStorage.id,
          standby_status: 0,
          motive: null,
        });
      })
      .then(() => {
        this.handleStandbyClose();
      })
      .then(() => {
        this.props.getUserRequestInfo();
      });
  };

  handleReopenProcess = () => {
    console.log(this.state);
    this.props.handleSubmit({
      is_canceled: false,
      cancel_reason: null,
      canceled_at: null,
    });
  };

  handleCancelClose = () => {
    this.setState({ cancelOpen: false });
  };

  handleStandbyClose = () => {
    this.setState({ standbyOnOpen: false });
    this.setState({ standbyOffOpen: false });
  };

  handleChange = (event) => {
    this.setState({ selectedValue: event.target.value });
  };

  isCanceled = () => {
    const { request } = this.props;
    return request.is_canceled;
  };

  isStandby = () => {
    const { request } = this.props;
    if (this.isCanceled()) return false;
    return request.standby;
  };

  isActive = () => {
    return !(this.isCanceled() || this.isStandby());
  };

  setForm(form) {
    this.form = form;
  }

  setStandbyForm(form) {
    this.standbyForm = form;
  }

  setCancelForm(form) {
    this.cancelForm = form;
  }

  submit() {
    if (this.form) {
      this.form.submitForm();
    }
  }

  submitCancelForm() {
    if (this.cancelForm) {
      const { submitForm, validateForm } = this.cancelForm.getFormikActions();
      const { setFieldTouched } = this.cancelForm.getFormikBag();
      validateForm().then((errors) => {
        var fieldsWithError = Object.keys(errors);
        if (fieldsWithError.length === 0) {
          submitForm();
          this.handleCancelClose();
        } else {
          fieldsWithError.forEach((key) => setFieldTouched(key));
        }
      });
    }
  }

  isSubmitting() {
    return this.form ? this.form.isSubmitting : false;
  }

  isSubmittingCancelForm() {
    return this.cancelForm ? this.cancelForm.isSubmitting : false;
  }

  handleSubmitting(fn) {
    return (values, actions) => {
      return fn(values)
        .then(() => actions.setSubmitting(false))
        .catch(() => actions.setSubmitting(false));
    };
  }

  selectCancelType(request) {
    if (request.request_type === "Disperso") {
      this.setState({ options: this.disperseCancelMotive });
    } else {
      if (request.request_type === "Exclusivo") {
        this.setState({ options: this.exclusiveCancelMotive });
      }
      this.setState({ options: this.validationCancelMotive });
    }
  }

  componentDidMount() {
    this.selectCancelType(this.props.request);
  }

  componentDidUpdate(prevProps) {
    const { request } = prevProps;

    if (request.request_type !== this.props.request.request_type)
      this.selectCancelType(this.props.request);
  }

  render() {
    const request = this.props.request;

    //Obter data do ultimo agendamento registado
    const bookcall = isEmpty(this.props.dateFromLastBookcall)
      ? null
      : moment(this.props.dateFromLastBookcall[0].book_to).format(
          "YYYY-MM-DD [às] HH:mm"
        );

    return (
      <>
        <ExpansionPanel square>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Grid container alignItems="center">
              <Grid item md={2}>
                <Typography variant="body2"> {request.request_type}</Typography>
              </Grid>

              <Grid item md={2}>
                <AdminView adminId={request.admin_id} label="CF" image={true} />
              </Grid>
              <Grid item md>
                {bookcall != null && (
                  <Typography variant="body2">
                    <b>Contacto agendado:</b>
                    <div>{bookcall}</div>
                  </Typography>
                )}
              </Grid>
              <Grid item md={2}>
                {request.elderly_name && (
                  <Typography className="name" variant="body2">
                    <b>Nome do Idoso:</b> {request.elderly_name}{" "}
                  </Typography>
                )}
              </Grid>
              <Grid item md>
                <Grid container justify="center" alignItems="center">
                  {this.isCanceled() && (
                    <>
                      <Chip label="Cancelado" />
                      <Grid item className={"helper"}>
                        <Typography variant="caption">
                          {moment(request.canceled_at).format(
                            "YYYY-MM-DD HH:mm"
                          )}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {this.isActive() &&
                    (request.type === "Disperso" ? (
                      <Chip label="Pendente" />
                    ) : (
                      <Chip label="Em Curso" />
                    ))}
                  {this.isStandby() && <Chip label="Standby" />}
                </Grid>
              </Grid>
              <Grid item md>
                <Typography variant="body2">
                  <b>Data Admissão Prevista:</b>{" "}
                  {REQUEST_PERIODS[request.request_period_id]}
                </Typography>
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <RequestDetailsForm
              userRequestStats={this.props.userRequestStats}
              onSubmit={this.props.handleSubmit}
              getForm={this.setForm}
              {...request}
            />
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <Grid container>
              <div>
                {/* ///////////////////////////////// CANCELAR PEDIDO//////////////////////////////// */}
                {!request.is_canceled && (
                  <>
                    <Button
                      size="small"
                      color="secondary"
                      onClick={this.handleCancelOpen}
                    >
                      Cancelar Pedido
                    </Button>

                    <Dialog
                      open={this.state.cancelOpen}
                      onClose={this.handleCancelClose}
                      aria-labelledby="form-dialog-title"
                      className="overflow-y-visible"
                      PaperProps={{
                        className: "overflow-y-visible",
                      }}
                    >
                      <DialogTitle id="form-dialog-title">
                        Cancelar Pedido
                      </DialogTitle>
                      <DialogContent className="overflow-y-visible">
                        <DialogContentText>
                          Por favor, seleccione o motivo do cancelamento:
                        </DialogContentText>
                        <br></br>
                        <Formik
                          ref={(node) =>
                            this.setCancelForm && this.setCancelForm(node)
                          }
                          initialValues={{
                            cancel_reason: request.cancel_reason || "",
                            is_canceled: true,
                            canceled_at: new Date(),
                          }}
                          onSubmit={this.handleSubmitting(
                            this.props.handleSubmit
                          )}
                          validateOnChange={true}
                          validateOnBlur={true}
                          validationSchema={validationSchemaCancel}
                          render={({
                            values,
                            errors,
                            status,
                            touched,
                            isSubmitting,
                            handleSubmit,
                            setFieldValue,
                            setFieldTouched,
                          }) => (
                            <form
                              onSubmit={handleSubmit}
                              className="overflow-y-visible"
                            >
                              <Field
                                name="cancel_reason"
                                label="Motivo Cancelamento"
                                search
                                options={this.state.options}
                                onChange={setFieldValue}
                                onBlur={setFieldTouched}
                                value={values.cancel_reason}
                                component={MaterialSelectFormik}
                              />
                            </form>
                          )}
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.submitCancelForm}
                          color="secondary"
                        >
                          Cancelar
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                )}

                {/* ////////////////////////// REABRIR PEDIDO///////////////////////////// */}
                {request.is_canceled && (
                  <>
                    <Button
                      size="small"
                      color="primary"
                      onClick={this.handleReopenProcess}
                    >
                      Reabrir Pedido
                    </Button>
                  </>
                )}

                {/* ////////////////////////////////// STAND BY ///////////////////////////// */}
                {request.standby ? (
                  <Button
                    size="small"
                    color="secondary"
                    onClick={this.openDialogTurnOffStandby}
                  >
                    Retirar de Standby
                  </Button>
                ) : (
                  <Button
                    size="small"
                    color="secondary"
                    onClick={this.openDialogTurnOnStandby}
                  >
                    Colocar em Standby
                  </Button>
                )}
                {/* /////////////////////// COLOCAR EM STAND BY //////////////////// */}
                <Dialog
                  open={this.state.standbyOnOpen}
                  onClose={this.handleStandbyClose}
                  aria-labelledby="form-dialog-title"
                  className="overflow-y-visible"
                  PaperProps={{
                    className: "overflow-y-visible",
                  }}
                >
                  <DialogTitle id="form-dialog-title">Standby</DialogTitle>
                  <DialogContent className="overflow-y-visible">
                    <DialogContentText className="overflow-y-visible">
                      Por favor, seleccione o motivo de colocar em stand-by:
                    </DialogContentText>
                    <Formik
                      ref={(node) =>
                        this.setStandbyForm && this.setStandbyForm(node)
                      }
                      initialValues={{
                        standby_motive: "",
                      }}
                      onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                          //console.log(JSON.stringify(values, null, 2));
                          this.setStandby(values);
                          setSubmitting(false);
                        }, 400);
                      }}
                      validateOnChange={true}
                      validateOnBlur={true}
                      validationSchema={validationSchemaStandby}
                      render={({
                        values,
                        errors,
                        status,
                        touched,
                        isSubmitting,
                        handleSubmit,
                        setFieldValue,
                        setFieldTouched,
                      }) => (
                        <form className="overflow-y-visible">
                          <Field
                            name="standby_motive"
                            label="Motivo Standby"
                            search
                            optionsFetcher={this.standbyOptionsPromise}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            value={values.standby_motive}
                            component={MaterialSelectFormik}
                          />
                          <Button onClick={handleSubmit} color="secondary">
                            Colocar em standby
                          </Button>
                          <Button
                            onClick={this.handleStandbyClose}
                            color="secondary"
                          >
                            Cancelar
                          </Button>
                        </form>
                      )}
                    />
                  </DialogContent>
                </Dialog>

                {/* ////////////////////////// RETIRAR DE STAND BY /////////////////////////// */}
                <Dialog
                  open={this.state.standbyOffOpen}
                  onClose={this.handleStandbyClose}
                  aria-labelledby="form-dialog-title"
                  className="overflow-y-visible"
                  PaperProps={{
                    className: "overflow-y-visible",
                  }}
                >
                  <DialogTitle id="form-dialog-title">Standby</DialogTitle>
                  <DialogContent className="overflow-y-visible">
                    De certeza que quer retirar de Standby?
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.turnOffStandby} color="secondary">
                      Sim
                    </Button>
                    <Button onClick={this.handleStandbyClose} color="secondary">
                      Não
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
              <Dialog>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary">
                    Cancel
                  </Button>
                  <Button onClick={this.handleClose} color="primary">
                    Save
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Button size="small" color="primary" onClick={() => this.submit()}>
              Save
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>
      </>
    );
  }
}
